import React, { ReactNode } from 'react';

import { colors, styled } from 'core/styles';
import { RedirectLinkProps } from 'domain/types';

import { NextLink } from '../NextLink';
import { ArrowWithBackgroundIcon } from '../icons';

export function SectionWithTitle({
  title,
  detailsLinkProps,
  titleContent,
  children,
}: {
  title: string;
  detailsLinkProps?: RedirectLinkProps;
  titleContent?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Root>
      {detailsLinkProps && (
        <TitleLink {...detailsLinkProps}>
          {title}
          <IconContainer>
            <ArrowWithBackgroundIcon fontSize="inherit" />
          </IconContainer>
        </TitleLink>
      )}
      {!detailsLinkProps && (
        <Title>
          <span>{title}</span>
          {titleContent}
        </Title>
      )}
      {children}
    </Root>
  );
}

const Root = styled('section')({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  fontSize: 24,
});

const Title = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 16,
  margin: 0,
  marginBottom: 8,
});

const TitleLink = styled(NextLink)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: 'max-content',
  marginBottom: 8,

  '& > span': {
    color: colors.smokyWhite,
  },

  '&:hover': {
    '& > span': {
      color: colors.silver,
    },
  },
});

const IconContainer = styled('span')(({ theme }) => ({
  fontSize: 28,
  transition: theme.transitions.create('all'),
}));
